import { render } from "./SingleQuestion.vue?vue&type=template&id=007cae27&scoped=true"
import script from "./SingleQuestion.vue?vue&type=script&lang=js"
export * from "./SingleQuestion.vue?vue&type=script&lang=js"

import "./SingleQuestion.vue?vue&type=style&index=0&id=007cae27&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007cae27"]])

export default __exports__